import { Api, decryptApiResponse } from "../../../../config/Api";
import { statusAndResponse } from "../../../../util/requestHandler";

export const getAllTransactions = async (params) => {
  return Api.get();
};

export function findFilterDate(clientId) {
  return statusAndResponse(
    Api.get(`/api/client/get/dateFilter/${clientId}`),
    decryptApiResponse,
  );
}
